module.exports = __webpack_public_path__ + "media/images/dashboard/light/tile_icon_adwords_top_keywords-3aa2f8c09d2a47852edcc2d05e759373.png";